import * as React from 'react';
export const metronomeDarkmodeSvg = React.forwardRef(
  function metronomeDarkmodeSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#002F2C',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M21.864 11.803h-2.618v9.573h2.618v-9.573Zm-4.582 3.527h-2.618v9.574h2.618V15.33ZM12.7 9.787h-2.618v9.574H12.7V9.787ZM8.118 7.1H5.5v17.803h2.618V7.1Zm18.327 0h-2.618v17.803h2.618V7.1Z',
        fill: '#AEE671',
      }),
    );
  },
);
metronomeDarkmodeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var metronomeDarkmode = {
  category: 'brand',
  colorable: false,
  name: 'metronomeDarkmode',
  svg: metronomeDarkmodeSvg,
};
